<template>
  <transition name="slide-fade" mode="out-in">
    <div class="right-sidebar flex flex-col bg-white border-solid border-l border-0 border-soft"
         :key="conversationJsonHash + bubbleSelected.actionId">
      <conversation-editor-read-only v-if="isConversationEditorReadOnlyShown || isTemplateVariant"
        :bot-id="botId"
        :item="item"
        :is-template-variant="isTemplateVariant"
        class="mt-8 px-12 w-full overflow-y-auto"
        @edit-market="$emit('edit-market')"
      />

      <template-selector v-else-if="templateSelector.isShown"
                         :bot-id="botId"
                         :state-id="templateSelector.stateId"
                         :is-inside-condition="templateSelector.isInsideCondition"
                         class="mt-5 overflow-y-auto"/>

      <AnswerUsages v-else-if="isAnswerUsagesShown"
                    :bot-id="botId"
                    :answer-id="answer.id"
                    class="mt-5 overflow-y-auto"/>

      <template-usages v-else-if="isTemplateUsagesShown"
                       :bot-id="botId"
                       :template-id="template.id"
                       class="mt-5 overflow-y-auto"/>

      <intent-description-editor v-else-if="bubbleSelected.type === PREVIEW_ITEM.CUSTOMER_BUBBLE && isGptBot"
                                 :bot-id="botId"
                                 class="w-full"
      />

      <intent-examples-sidebar v-else-if="bubbleSelected.type === PREVIEW_ITEM.CUSTOMER_BUBBLE"
                               :bot-id="botId"
                               class="w-full"
      />

      <template-ref-editor v-else-if="bubbleSelected.isTemplate"
                           :bot-id="botId"
                           class="mt-5 px-12 pb-8 overflow-y-auto"/>

      <answer-end-editor v-else-if="bubbleSelected.type === PREVIEW_ITEM.ANSWER_END"
                         :key="bubbleSelected.value"
                         :bot-id="botId"
                         class="mt-8 px-12 h-full w-full overflow-y-auto"/>

      <wait-for-input-editor v-else-if="bubbleSelected.type === PREVIEW_ITEM.WAIT_FOR_INPUT"
                             class="mt-8 px-12 w-full overflow-y-auto"/>

      <api-call-editor v-else-if="bubbleSelected.type === PREVIEW_ITEM.REMOTE_BUBBLE"
                       class="mt-8 px-12 w-full overflow-y-auto"/>

      <chat-GPT-editor v-else-if="bubbleSelected.type === PREVIEW_ITEM.CHAT_GPT_BUBBLE"
                       class="mt-8 px-12 pb-10 w-full overflow-y-auto"/>

      <condition-editor v-else-if="bubbleSelected.type === PREVIEW_ITEM.CONDITION_SECTION"
                        :bot-id="botId"
                        :condition-state-id="bubbleSelected.stateId"
                        class="overflow-y-auto"/>

      <chat-editor v-else :bot-id="botId" class="overflow-y-auto"/>
    </div>
  </transition>
</template>

<script>
import AnswerEndEditor from './AnswerEndEditor'
import AnswerUsages from './AnswerUsages'
import ApiCallEditor from './ApiCallEditor'
import ChatEditor from './message/ChatEditor'
import ConditionEditor from './condition/ConditionEditor'
import IntentExamplesSidebar from './example/IntentExamplesSidebar'
import WaitForInputEditor from './WaitForInputEditor'
import ConversationEditorReadOnly from './ConversationEditorReadOnly'
import TemplateSelector from './template-selector/TemplateSelector.vue'
import TemplateUsages from './TemplateUsages'
import TemplateRefEditor from './TemplateRefEditor'
import answerModule from '@/store/modules/answer.module'
import botModule from '@/store/modules/bot.module'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import conversationModule from '@/store/modules/conversation.module'
import templateModule from '@/store/modules/template.module'
import templateSelectorModule from '@/store/modules/template-selector.module'
import { PREVIEW_ITEM } from '@/store/constants'
import ChatGPTEditor from '@/components/editor/ChatGPTEditor.vue'
import IntentDescriptionEditor from '@/components/editor/IntentDescriptionEditor.vue'

export default {

  props: {
    botId: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: false
    },
    isTemplateVariant: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      PREVIEW_ITEM
    }
  },

  components: {
    ChatGPTEditor,
    IntentDescriptionEditor,
    AnswerUsages,
    AnswerEndEditor,
    ApiCallEditor,
    ChatEditor,
    ConditionEditor,
    IntentExamplesSidebar,
    WaitForInputEditor,
    TemplateSelector,
    TemplateUsages,
    TemplateRefEditor,
    ConversationEditorReadOnly
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    templateSelector: templateSelectorModule.templateSelector,
    isAnswerUsagesShown: answerModule.isAnswerUsagesShown,
    isTemplateUsagesShown: templateModule.isTemplateUsagesShown,
    answer: answerModule.getAnswer,
    template: templateModule.template,

    conversationJsonHash() {
      return conversationModule.getRootJsonHash()
    },

    isGptBot() {
      return botModule.isGptBot()
    },

    isConversationEditorReadOnlyShown() {
      return this.item?.inheritsConversation || false
    }
  },

  watch: {
    bubbleSelected() {
      templateSelectorModule.hideSelector()
    }
  },

  destroyed() {
    templateSelectorModule.hideSelector()
  }
}
</script>

<style scoped>
.right-sidebar {
  height: calc(100vh - 100px);
  overflow: hidden;
  flex-shrink: 0;
}

.header {
  min-height: 100px;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
